export interface AdSpotAiringSource {
  id: string
  title: string
  airingsCount: number
}

const frenchTitleCollator = new Intl.Collator('fr-FR', { numeric: true, sensitivity: 'base' })

/** Retourne une nouvelle liste, des spots les moins diffusés aux plus diffusés. */
export function orderByLeastAired<T extends AdSpotAiringSource>(spots: readonly T[]): T[] {
  return [...spots].sort((left, right) => (
    left.airingsCount - right.airingsCount
    || frenchTitleCollator.compare(left.title, right.title)
    || left.id.localeCompare(right.id)
  ))
}

export function formatSpotAirings(count: number): string {
  return `${count} diffusion${count === 1 ? '' : 's'}`
}
